// ---------------------------------------------
// autofirma.esm.js
// ---------------------------------------------

import './autoscript.js';
import './batchscript.js';

function waitForAutoScript(maxWaitMs = 4000) {
  return new Promise((resolve, reject) => {
    const start = Date.now();

    function check() {
      if (window.MiniApplet || window.AutoScript) {
        resolve(window.MiniApplet || window.AutoScript);
        return;
      }

      if (Date.now() - start > maxWaitMs) {
        reject(
          new Error(
            'AutoScript no se inicializó a tiempo. ' +
            'Comprueba que autoscript.js y batchscript.js cargan correctamente.'
          )
        );
        return;
      }

      requestAnimationFrame(check);
    }

    check();
  });
}



export const AutoScriptReady = waitForAutoScript();

const MiniAppletExport = window.MiniApplet || window.AutoScript;

if (MiniAppletExport && typeof MiniAppletExport === 'object') {
  MiniAppletExport.cargarMiniAppletJA = cargarMiniAppletJA;
}

if (typeof window !== 'undefined') {
  window.cargarMiniAppletJA = cargarMiniAppletJA;
}

export default MiniAppletExport;
export const MiniApplet = MiniAppletExport;
export const AutoScript = MiniAppletExport;
export const BatchScript = window.BatchScript;
export const doSignBatch = window.doSignBatch;

export function cargarMiniAppletJA(...args) {
  const api = window.MiniApplet || window.AutoScript;

  if (!api) {
    throw new Error(
      'MiniApplet/AutoScript todavía no está disponible. ' +
      'Espera a AutoScriptReady antes de usarlo.'
    );
  }

  if (typeof api.cargarMiniApplet === 'function') {
    return api.cargarMiniApplet(...args);
  }

  if (typeof api.cargarAppAfirma === 'function') {
    return api.cargarAppAfirma(...args);
  }

  throw new Error(
    'No existe ni cargarMiniApplet ni cargarAppAfirma en la API de AutoFirma.'
  );
}